import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const MonogDb = () => {
  return (
    <StartInterviewLayout type="mongodb"/>
  )
}

export default MonogDb;